<script>
    import Fa from 'svelte-fa/src/fa.svelte'
    import { faEdit, faTag  } from '@fortawesome/free-solid-svg-icons'
    import Dialog from './Dialog.svelte';
    //import { Product } from "proto/products_pb.js";
    import { createEventDispatcher, onMount } from 'svelte';
    import ManageSingleProduct from './manage-products/ManageSingleProduct.svelte';
    import { isHolidayOrOutsideWorkingHours } from './config';
    import { hasDiscount } from './stores/products';
    import analytics from './services/analytics.js';
      const dispatch = createEventDispatcher();

    export let count = 1;
    /**
     * @type {(a: import('./proto/products_pb.d').Product) => void}
     */
    export let updateProduct;
    /**
     * @type {(a: import('./proto/products_pb.d').Product) => void}
     */
    export let deleteProduct;

    /**
     * @param {Event} e
     * @param {() => void} cancelDialog
     */
     const handleSubmit = (e, cancelDialog) => {
      e.stopPropagation();
      cancelDialog();
      for(let i = 0; i < count; i++) {
        onAddToCart(item);
      }
    };
   /**
     * @type {import('./proto/products_pb.d').Product}
    */
    export let item;
    export let canEdit = false;
    export let onEdit = () => {
    };
    /**
     * @type {(a: import('./proto/products_pb.d').Product) => void}
    */
    export let onAddToCart;
    let isOpen = false;
    let isOpenEdit = false;

    /**
     * @param {Event} e
     */
    function handleButtonClick(e) {
        e.stopPropagation();
        onAddToCart(item);
    }

    /**
     * @param {Event} e
     */
    function openEditDialog(e) {
        e.stopPropagation();
        isOpenEdit = true;
    }
    
    /**
     * Track product click and open dialog
     */
    function openProductDialog() {
      analytics.trackProductClick(item);
      isOpen = true;
    }

    // Add a computed property to check if the product is unavailable
    $: isUnavailable = item.getCategory() === 'Неналични';
    $: siteUnavailable = isHolidayOrOutsideWorkingHours();
</script>

<div class="bg-white rounded-lg shadow-lg cursor-pointer flex flex-col relative" on:click={openProductDialog}>
    {#if isUnavailable}
        <div class="absolute top-0 right-0 bg-red-500 text-white px-2 py-1 rounded-bl-lg shadow-md">
            <span class="font-semibold">Неналични</span>
        </div>
    {/if}
    <img src={item.getUrl()} alt={item.getName()} class="w-full object-contain rounded-t-lg max-h-56 h-56 object-contain" />
    <div class="p-4 flex flex-col flex-grow">
        <h1 class="text-gray-900 font-bold text-2xl overflow-hidden">{item.getName()}</h1>
        <div class="flex-grow"></div>
        <span class="text-gray-700 font-semibold text-sm">{item.getCategory()}</span>
        <!-- buy now button  -->
        <div class="flex flex-col md:flex-row items-center md:justify-end mt-2 md:flex-wrap">
            <div class="flex items-center w-full md:w-auto mt-2">
                <Fa icon={faTag} size="2x" />
                <div class="ml-2">
                    {#if hasDiscount(item)}
                        <div class="text-gray-500 line-through">{item.getPrice().toFixed(2)} лв.</div>
                        <div class="text-red-500 font-bold">{item.getDiscountedprice().toFixed(2)} лв.</div>
                    {:else}
                        <div class="text-gray-900 font-bold">{item.getPrice().toFixed(2)} лв.</div>
                    {/if}
                </div>
            </div>
            <div class="flex-grow md:flex-shrink"></div>
            {#if canEdit}
                <button class="w-full md:w-auto button mt-4 md:mt-0" on:click={openEditDialog}>
                    <Fa icon={faEdit}/>
                    Промени
                </button>
            {/if}

            <button class="w-full md:w-auto button mt-4 md:mt-0" on:click={handleButtonClick} disabled={isUnavailable || siteUnavailable}>
                Купи
            </button>
        </div>
    </div>
</div>


<Dialog bind:isOpen let:isOpen let:closeDialog>
  <div class="bg-white p-4 sm:p-6 sm:pb-4 rounded-t-lg">
    <div class="sm:flex sm:items-start sm:flex-col mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
      <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
      Направи поръчка
      </h3>
      <div class="flex flex-col md:flex-row gap-4 text-left relative">
        {#if isUnavailable}
            <div class="absolute top-0 right-0 md:top-6 md:left-16 md:right-auto bg-red-500 text-white px-2 py-1 rounded-bl-lg">
                Неналични
            </div>
            <img src={item.getUrl()} alt="Product Image" class="h-40 aspect-square object-cover rounded-md" />
        {:else}
            <img src={item.getUrl()} alt="Product Image" class="h-40 aspect-square object-cover rounded-md" />
        {/if}
        <div class="mt-2 flex flex-col">
          <p class="text-gray-700">{item.getDescription()}</p>
          {#if hasDiscount(item)}
              <h2 class="text-2xl mt-2 mb-2 font-bold text-gray-500 line-through">{item.getPrice().toFixed(2)} лв.</h2>
              <h2 class="text-2xl mt-2 mb-2 font-bold text-red-500">{item.getDiscountedprice().toFixed(2)} лв.</h2>
          {:else}
              <h2 class="text-2xl mt-2 mb-2 font-bold text-gray-900">{item.getPrice().toFixed(2)} лв.</h2>
          {/if}
          <div class="flex flex-row gap-3">
              <input
              class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mt-2"
              id="count"
              type="number"
              min="1"
              placeholder="Number of items"
              bind:value={count}
              >
              <button
              type="button"
              class="w-full inline-flex justify-center button mt-4 md:mt-0"
              on:click={(e) => handleSubmit(e, closeDialog)}
              disabled={isUnavailable || siteUnavailable}
              >
              Купи
              </button>
          </div>

        </div>
    </div>
      <button
      type="button"
      class="absolute top-0 right-0 m-2 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
      on:click={closeDialog}
      >
      X
      </button>
    </div>
</Dialog>

<!-- Edit dialog -->
<Dialog bind:isOpen={isOpenEdit} let:closeDialog>
      <button
      type="button"
      class="absolute top-0 right-0 m-2 bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
      on:click={closeDialog}
      >
      X
      </button>
    <div class="m-6">
        <ManageSingleProduct product={item} deleteProduct={deleteProduct} updateProduct={updateProduct} />
    </div>
</Dialog>